import React, { useState, useEffect } from "react";
import {
  GoogleMap,
  Marker,
  MarkerF,
  useJsApiLoader,
} from "@react-google-maps/api";

interface GoogleMapProps {
  googlePlaceLongAddress?: string;
}

const containerStyle = {
  width: "100%",
  height: "450px",
};

const defaultCenter = {
  lat: 59.95,
  lng: 30.33,
};

const GoogleMapComponent: React.FC<GoogleMapProps> = ({
  googlePlaceLongAddress,
}) => {
  const [mapCenter, setMapCenter] = useState(defaultCenter);
  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyCRlKKWTlfsbs1bdQ6ziL9e9ptaiOJbnqI",
    libraries: ["places"],
  });

  useEffect(() => {
    if (!isLoaded || !googlePlaceLongAddress) {
      // If the API is not loaded or there's no address, don't attempt to geocode
      return;
    }

    // Perform geocoding only after confirming the API is loaded
    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ address: googlePlaceLongAddress }, (results, status) => {
      if (status === google.maps.GeocoderStatus.OK && results) {
        // Extract the latitude and longitude from the geocode result
        const location = results[0].geometry.location;
        setMapCenter({
          lat: location.lat(),
          lng: location.lng(),
        });
        console.log("Marker should be set at:", location.lat(), location.lng()); // Log the lat/lng for debugging
      } else {
        console.error(
          "Geocode was not successful for the following reason:",
          status,
        );
      }
    });
  }, [isLoaded, googlePlaceLongAddress]);

  if (loadError) {
    console.error("Error loading Google Maps", loadError);
    return <div>Map cannot be loaded right now, sorry.</div>;
  }

  if (!isLoaded) {
    return <div>Loading...</div>;
  }

  // Render the GoogleMap and Marker only after the API is loaded
  return (
    <GoogleMap mapContainerStyle={containerStyle} center={mapCenter} zoom={14}>
      <Marker position={mapCenter} />
      <MarkerF position={mapCenter} />
    </GoogleMap>
  );
};

export default GoogleMapComponent;
